const separator: string = ' さん: '

export const redactUserNameInBookingSummary = (
  bookingSummary: string
): string => {
  // summary のフォーマット: '{{ userName }} さん: {{ title }}'
  // ref: https://github.com/400f/superfrog/blob/7a3cce6ff95cd04b7ade47c7f6ada4429b40040f/internal/app/usecase/calendarservice/calendar.go#L197
  //
  // userName や calendarTitle を取得せずに separator で split している理由は、
  // bookingSummary が予約時のスナップショットであるのに対して userName や calendarTitle は変わり得るため
  const [userName, ...rest] = bookingSummary.split(separator)
  const redactedUserName = userName
    .split('')
    .map((char, index) => (index === 0 ? char : '＊'))
    .join('')

  return rest.length !== 0
    ? redactedUserName + separator + rest.join(separator)
    : redactedUserName
}
